import Fetcher from "./Shared/FetchService";
export default class InstitutionMetricsService {
    static getMetrics() {
        return Fetcher.getSingleResponse("/aviso/successMetrics/metricsData");
    }
}
